export default '2.0.0';



// WEBPACK FOOTER //
// ./version.js